<template>
    <div>
        <div class="entry-header">
            <div class="header-title">免费开店，享多项权益</div>
            <div class="entry-content">
                <div class="entry-item">
                    <img src="~@/assets/images/63.png" alt="" class="entry-icon">
                    <div class="entry-text">解锁0元开店</div>
                </div>
                <div class="entry-item">
                    <img src="~@/assets/images/64.png" alt="" class="entry-icon">
                    <div class="entry-text">{{ not_settled.user_num }}+用户</div>
                </div>
                <div class="entry-item">
                    <img src="~@/assets/images/65.png" alt="" class="entry-icon">
                    <div class="entry-text">{{ not_settled.supply_num }}+供求信息</div>
                </div>
                <div class="entry-item">
                    <img src="~@/assets/images/66.png" alt="" class="entry-icon">
                    <div class="entry-text">{{ not_settled.good_num }}免费发</div>
                </div>
            </div>
            <el-button type="primary" class="entry-btn" @click="handleEntryClick">免费开店</el-button>
        </div>
        <div class="entry-mid">
            <div>
                <div class="mid-num">10万+</div>
                <div class="mid-text">供应商</div>
            </div>
            <div>
                <div class="mid-num">10万+</div>
                <div class="mid-text">供应商</div>
            </div>
            <div>
                <div class="mid-num">10万+</div>
                <div class="mid-text">供应商</div>
            </div>
        </div>
        <div class="entry-footer">
            <div>
                <div class="footer-num">交易撮合服务</div>
                <div class="footer-text">全国领先的农业专业批发平台</div>
            </div>
            <div>
                <div class="footer-num">交易撮合服务</div>
                <div class="footer-text">全国领先的农业专业批发平台</div>
            </div>
            <div>
                <div class="footer-num">十万活跃采购商</div>
                <div class="footer-text">覆盖农、林、牧、副、渔类目</div>
            </div>
            <div>
                <div class="footer-num">海量常见品类</div>
                <div class="footer-text">精准匹配撮合，大家交易更省心</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ShopEntry',
    data() {
        return {
            shopEntryForm: {
                shopName: '',
                shopAddress: '',
                shopPhone: '',
                shopEmail: '',
                shopIntroduction: '',
            },
            not_settled: {
                user_num: "",
                supply_num: "",
                good_num: ""
            },
        }
    },
    mounted() {
        // 获取开店可享权益
        this.getShopEntry()
    },
    methods: {
        getShopEntry() {
            this.$api.getShopEntry().then(res => {
                this.not_settled = res;
            }).catch(err => {
                this.$message.warning(err)
            })
        },
        handleEntryClick() {
            this.$emit('goToComponent', 'ShopAuthentication');
        }
    }
}
</script>
<style scoped>
.entry-header {
    width: 100%;
    background: url(~@/assets/images/62.png) no-repeat;
    background-size: 100% auto;
    padding-top: 48px;
}

.header-title {
    font-weight: bold;
    font-size: 24px;
    color: #286CED;
}

.entry-content {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 32px;
}

.entry-icon {
    width: 48px;
    height: 48px;
}

.entry-text {
    margin-top: 18px;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
}

.entry-btn {
    margin-top: 32px;
    width: 272px;
    height: 48px;
    background: #286CED;
    border-radius: 6px 6px 6px 6px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
}

.entry-mid {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 32px;
    background: url(~@/assets/images/67.png) no-repeat;
    background-size: 100% auto;
    padding: 32px 0;
}

.mid-num {
    font-weight: bold;
    font-size: 24px;
    color: #FFFFFF;
}

.mid-text {
    font-weight: 500;
    font-size: 16px;
    color: #FFFFFF;
}

.entry-footer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 32px;
    margin-bottom: 32px;
}

.footer-num {
    font-weight: bold;
    font-size: 18px;
    color: #333;
}

.footer-text {
    font-weight: 500;
    font-size: 14px;
    color: #999;
}
</style>
